import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  footer: {
    height: '80px',
    marginTop: '20px',
    backgroundColor: '#faab4b',
    position: 'relative'
  },
  container: {
    position: 'absolute',
    right: '0',
    bottom: '0'
  }
});

function Copyright() {
  return (
    <Typography align="right">
      <small>{'© 2020 Studio Arcana, Inc.'}</small>
    </Typography>
  );
}

function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Container className={classes.container}>
        <Copyright />
      </Container>
    </footer>
  );
}

export default Footer;
